import { toIsoTimestamp } from './time';

export function applyMessageUpdateToMessages(previousMessages, update) {
  const prev = Array.isArray(previousMessages) ? previousMessages : [];
  const idx = prev.findIndex((message) => message.id === update.messageId);
  const normalizedUpdateTimestamp = update.timestamp ? toIsoTimestamp(update.timestamp) : null;

  if (idx >= 0) {
    const updated = [...prev];
    updated[idx] = {
      ...updated[idx],
      content: update.content ?? updated[idx].content,
      isComplete: update.isComplete ?? updated[idx].isComplete,
      timestamp: normalizedUpdateTimestamp || updated[idx].timestamp,
      createdAt: normalizedUpdateTimestamp || updated[idx].createdAt
    };
    return updated;
  }

  return [
    ...prev,
    {
      id: update.messageId,
      conversationId: update.conversationId,
      content: update.content,
      isComplete: update.isComplete,
      role: 'assistant',
      senderId: 'kapsa-ai',
      senderDisplayName: 'Kapsa AI',
      createdAt: normalizedUpdateTimestamp || toIsoTimestamp(update.timestamp),
      timestamp: normalizedUpdateTimestamp || toIsoTimestamp(update.timestamp)
    }
  ];
}
